import React, { Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
//Limitless imports
import PortalTextInput from "../../form-elements/portal-text-input/PortalTextInput";
import FormMessage from "../form-message/FormMessage";
import { Typography } from "@mui/material";
import { useTranslation } from "@limitless/common/hooks";
import { generalTextInputStyles } from "./PortalSignInForm";
const useStyles = makeStyles(theme => ({
  ...generalTextInputStyles(theme),
  messageContainer: {
    height: 32
  },
  resendButton: {
    padding: 0,
    alignSelf: "center",
    paddingBottom: 2
  },
  textInput: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 8
  }
}));
const ResendCodeForm = ({
  onResendClick,
  errorMessage,
  onChange,
  loading,
  value,
  fieldError
}) => {
  const [showCheckEmail, setShowCheckEmail] = React.useState(false);
  const {
    t
  } = useTranslation();
  const classes = useStyles();
  const handleResendClick = () => {
    onResendClick();
    setShowCheckEmail(true);
    setTimeout(() => {
      setShowCheckEmail(false);
    }, 5000);
  };
  return /*#__PURE__*/React.createElement(Fragment, null, !showCheckEmail ? /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(FormMessage, {
    errorMessage: errorMessage,
    infoMessage: "Haven't received an email? ",
    containerClass: classes.messageContainer
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: handleResendClick,
    classes: {
      root: classes.resendButton
    },
    id: "resendRegistrationCodeButton"
  }, t("Resend Code")))) : /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    variant: "body1",
    align: "center",
    className: classes.messageContainer
  }, t("Check your email for the code")), /*#__PURE__*/React.createElement(PortalTextInput, {
    name: "email",
    label: "Registration Code",
    placeholder: "Check your email for the code",
    id: "registrationCodeInputField",
    onChange: event => onChange(event.target.value),
    disabled: loading,
    value: value,
    error: fieldError ? true : false,
    helperText: fieldError,
    containerClass: classes.textInput,
    autoComplete: "false",
    color: "primary",
    inputProps: {
      className: classes.textInputStyle
    },
    textInputClasses: {
      notchedOutline: classes.noBorderInput
    },
    largeHelperText: true,
    errorLabel: true
  }));
};
export default ResendCodeForm;
ResendCodeForm.propTypes = {
  errorMessage: PropTypes.string,
  onResendClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fieldError: PropTypes.string,
  value: PropTypes.string
};